import { Linking, Platform } from 'react-native';

/**
 * Open native settings app to notifications
 *
 * - `native`: Linking.openSettings()
 * - `default`: noop
 */
const openNativeSettingsApp = () =>
  Platform.select({
    native: async () => Linking.openSettings(),
    default: async () => undefined,
  })();

/**
 * Open native settings app to location permissions
 *
 * @iOS current behavior is to just open the settings app without navigating to the Volo
 * app settings, as that is incorrect behavior in finding
 * the location permission settings.
 *
 * @important latest iOS settings (18+) seem to have removed the ability open `Privacy` settings within the Settings app. Leaving for possible older version support.
 *
 * There is also about 0 information on this topic but did find a lib that is no longer maintained that *used* to be able to open the location settings which would have looked like the below iOS link.
 *
 * @see https://github.com/votrai123/react-native-open-settings-devices/blob/master/ios/OpenSettings.mm
 *
 * ---
 *
 * - `iOS`: App-prefs:Privacy&path=LOCATION
 * - `Android`: Linking.openSettings()
 * - `default`: noop
 */
const openLocationSettings = () =>
  Platform.select({
    ios: async () => Linking.openURL('App-prefs:Privacy&path=LOCATION'),
    android: async () => Linking.openSettings(),
    default: async () => undefined,
  })();

/**
 * Generic method to open specific settings sections
 *
 * -`volo-app`: Opens the Native Settings App > Volo App {@link openNativeSettingsApp}
 *
 * -`location`: {@link openLocationSettings}
 *
 * -`general`: Opens the Native Settings App (iOS)
 */
const openSpecificSettings = (settingsType: 'volo-app' | 'location' | 'general') => {
  switch (settingsType) {
    case 'volo-app':
      return openNativeSettingsApp();
    case 'location':
      return openLocationSettings();
    case 'general':
    default:
      return Platform.select({
        ios: async () => Linking.openURL('App-prefs:'),
        android: async () => Linking.openSettings(),
        default: async () => undefined,
      })();
  }
};

export default openNativeSettingsApp;
export { openLocationSettings, openSpecificSettings };
